import { defineMessages } from 'react-intl';
import type { MessageValue, NoMessageValues } from 'react-intl';

export const downloadItemMessages = defineMessages({
  ASSEMBLY_INSTRUCTIONS: {
    defaultMessage: 'Aufbauanleitung',
    id: 'efficiencyFlagDownloads.type.assembly',
  },
  PRODUCT_DATASHEET: {
    defaultMessage: 'Produktdatenblatt',
    id: 'efficiencyFlagDownloads.type.productdatasheet',
  },
  SAFETY_DATASHEET: {
    defaultMessage: 'Sicherheitsdatenblatt',
    id: 'efficiencyFlagDownloads.type.safetydatasheet',
  },
  USER_MANUAL: {
    defaultMessage: 'Gebrauchsanleitung',
    id: 'efficiencyFlagDownloads.type.usermanual',
  },
  MANUFACTURER_WARRANTY: {
    defaultMessage: 'Hersteller Garantie',
    id: 'efficiencyFlagDownloads.type.manufacturerwarranty',
  },
  WARNING_LABEL: {
    defaultMessage: 'Warnhinweis',
    id: 'efficiencyFlagDownloads.type.warninglabel',
  },
});

/** Screen reader only texts that complete the visible name of a download link. */
export const downloadItemA11yMessages = defineMessages<{
  readonly pdfInNewTab: NoMessageValues;
  readonly forProduct: { readonly productName: MessageValue };
}>({
  pdfInNewTab: {
    id: 'efficiencyFlagDownloads.a11y.text',
    defaultMessage: '(PDF, öffnet in neuem Tab)',
  },
  forProduct: {
    id: 'efficiencyFlagDownloads.a11y.forProduct',
    defaultMessage: 'für Produkt {productName}',
  },
});
